


























// @TODO: `[Vuetify] Image load failed` is shown on-error, tho we can ignore it. See how to remove that logged error.
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import ContentImage from '@/components/ContentImage.vue'

@Component({
  components: { ContentImage },
})
export default class UrlPageContentImage extends Vue {
  @Prop({ required: true, type: String }) src!: string
  @Prop({ required: true, type: String }) contentSrc!: string

  get domain() {
    return (new URL(this.contentSrc)).hostname
  }
}

